import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

type Props = TooltipProps & {extraWidth?: boolean};

export const LightTooltip = (props: Props) => {
  return props.title ? <TooltipCustomized {...props} /> : <>{props.children}</>;
};

const TooltipCustomized = styled(({ className, extraWidth, ...props }: Props) => (
  <Tooltip placement="bottom" {...props} arrow classes={{ popper: className }} />
))(({ style, extraWidth }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--tooltip-background)',
    fontSize: 18,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'var(--tooltip-background)',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    padding: '12px',
    fontFamily: 'var(--font-primary)',
    backgroundColor: 'var(--tooltip-background)',
    color: 'var(--tooltip-color)',
    maxWidth: extraWidth ? 500 : 200,
    lineHeight: 1.2,
    fontSize: 12,
    fontWeight: 400,
    border: '1px solid var(--tooltip-border-color)',
    filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))',
  },
}));
